<script>
    import LoadingModal from "../../../Components/Common/LoadingModal.svelte";

    import {
        SvelteTable,
        TableElementEditableStatus,
        TableElementEditableReceiveDate,
        TableElementEditableAmount,
        CollapsibleTableIcons,
        CardLayout,
        NotificationModal,
        TableElementEditableTransactionDate,
    } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        formatPortalUrls,
        getAmountInCurrency,
        getEstimatePaidBy,
        getEstimatePaidFor,
        getEstimatePaidMethod,
        getFormatDateAndTime,
        getText,
        goToDownloadPage,
        goToURL,
        openPortalPage,
        showError,
        showException,
        splitPaymentAmount,
    } from "../../../Utils/utilFunctions.svelte";
    import { PatientPayInsuranceTypes } from "../../../Utils/utilEnums.svelte";

    export let estimatePayments = [];
    export let isUserDoctor = false;
    export let isUserEnableSeePaymentReceive = false;
    export let reload = () => {};
    export let openRecordPaymentModal = () => {};
    export let patientDetails;

    let isDownloadingPayment = false,
        isRegeneratingPayment = false;

    let isSendingReceiptToPatient = false,
        isReceiptSendToPatient = false;

    let isSendingPaymentRefundCollectPatientBankDetails = false,
        isPaymentRefundCollectPatientBankDetailsSendToPatient = false;

    $: if (isUserEnableSeePaymentReceive)
        columnsForAdmin.splice(12, 0, {
            key: "paymentStatus",
            title: "Status",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderComponent: {
                component: TableElementEditableStatus,
                props: {
                    type: "paymentFromView",
                    onFinish: () => reload(),
                },
            },
        });

    const columnsForAdmin = [
        {
            key: "id",
            title: "Receipt ID",
            headerClass: "text-left px-3 cursor-default rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default",
            renderValue: (v) => _getReceiptId(v.receiptId),
        },
        {
            key: "paymentId",
            title: "Payment ID",
            headerClass: "text-left px-3 cursor-default rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default",
            renderValue: (v) => getText(v.id),
        },
        {
            key: "paidFor",
            title: "Paid for",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => getEstimatePaidFor(v.relTo),
        },
        {
            key: "paidForId",
            title: "Paid for ID",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => getText(v.relId),
        },
        {
            key: "dateConfirmed",
            title: "Date Created",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => _getFormatDate(v.createdDate),
        },
        {
            key: "transactionDate",
            title: "Date Received",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderComponent: {
                component: TableElementEditableTransactionDate,
                props: {
                    type: "EstimatePaymentTable",
                    onFinish: () => reload(),
                },
            },
        },
        {
            key: "receiveDate",
            title: "Date Reconciled",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderComponent: {
                component: TableElementEditableReceiveDate,
                props: {
                    type: "EstimatePaymentTable",
                    onFinish: () => reload(),
                },
            },
        },
        {
            key: "paidBy",
            title: "Paid By",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => `${getEstimatePaidBy(v.paidBy)}`,
        },
        {
            key: "paidMethod",
            title: "Payment Method",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => `${getEstimatePaidMethod(v.paymentMethod)}`,
        },
        {
            key: "amount",
            title: "Subtotal Amount",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderComponent: {
                component: TableElementEditableAmount,
                props: {
                    type: "EstimatePaymentsTable",
                    onFinish: () => reload(),
                },
            },
        },
        {
            key: "processingFee",
            title: "Processing Fee",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => getAmountInCurrency(v.processingFee),
        },
        {
            key: "gst",
            title: "GST",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3",
            renderValue: (v) =>
                getAmountInCurrency(
                    v.includesGST ? splitPaymentAmount(v).gst : 0,
                ),
        },
        {
            key: "total",
            title: "Total Amount",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3",
            renderValue: (v) =>
                getAmountInCurrency(splitPaymentAmount(v).total),
        },
        {
            key: "transactionId",
            title: "Transaction ID",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => getText(v.transactionId),
        },
        {
            key: "approvalNumber",
            title: "Reference",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => getText(v.approvalNumber),
        },
        {
            key: "buttons",
            title: "",
            headerClass: "text-left pl-3 cursor-default rounded-tr-xl w-[5%]",
            class: "text-left px-3 cursor-default w-[5%]",
            renderComponent: {
                component: CollapsibleTableIcons,
                props: {
                    icons: [
                        "downloadLinkIcon",
                        "downloadIcon",
                        "reGenerateIcon",
                        "sendToPatientIcon",
                        "editPaymentIcon",
                        "sendRefundConfirmationIcon",
                        "goToPortalPageIcon",
                    ],
                    tableType: "Receipt",
                    showPatientInDownload: PatientPayInsuranceTypes.includes(
                        patientDetails?.insuranceType,
                    ),
                },
            },
        },
    ];

    const columnsForDoctor = [
        {
            key: "id",
            title: "Receipt ID",
            headerClass: "text-left px-3 cursor-default rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default",
            renderValue: (v) => _getReceiptId(v.receiptId),
        },
        {
            key: "paymentId",
            title: "Payment ID",
            headerClass: "text-left px-3 cursor-default rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default",
            renderValue: (v) => getText(v.id),
        },
        {
            key: "paidFor",
            title: "Paid for",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => getEstimatePaidFor(v.relTo),
        },
        {
            key: "paidForId",
            title: "Paid for ID",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => getText(v.relId),
        },
        {
            key: "dateConfirmed",
            title: "Date Created",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => _getFormatDate(v.createdDate),
        },
        {
            key: "paidBy",
            title: "Paid By",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => `${getEstimatePaidBy(v.paidBy)}`,
        },
        {
            key: "paidMethod",
            title: "Payment Method",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => `${getEstimatePaidMethod(v.paymentMethod)}`,
        },
        {
            key: "amount",
            title: "Amount",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => _getAmountForDoctor(v.amount, v.processingFee),
        },
        {
            key: "transactionId",
            title: "Transaction ID",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => getText(v.transactionId),
        },
        {
            key: "approvalNumber",
            title: "Reference",
            headerClass: "text-left pl-3 cursor-default",
            class: "text-left px-3 cursor-default",
            value: (v) => getText(v.approvalNumber),
        },
        {
            key: "buttons",
            title: "",
            headerClass: "text-left pl-3 cursor-default rounded-tr-xl w-[5%]",
            class: "text-left px-3 cursor-pointer w-[5%]",
            renderComponent: {
                component: CollapsibleTableIcons,
                props: {
                    icons: [
                        "downloadLinkIcon",
                        "downloadIcon",
                        "reGenerateIcon",
                        "sendToPatientIcon",
                        "editPaymentIcon",
                        "sendRefundConfirmationIcon",
                        "goToPortalPageIcon",
                    ],
                    tableType: "Receipt",
                    showPatientInDownload: PatientPayInsuranceTypes.includes(
                        patientDetails?.insuranceType,
                    ),
                },
            },
        },
    ];

    const columns = isUserDoctor ? columnsForDoctor : columnsForAdmin;

    const handleClickCell = (
        { target: { className, classList } },
        rowData,
        key,
    ) => {
        if (key == "buttons") {
            if (classList.contains("downloadIcon"))
                downloadPayment(rowData.receiptId);
            else if (classList.contains("reGenerateIcon"))
                regeneratePayment(rowData);
            else if (className.includes("goToPortalPageIcon"))
                openPortalPage(rowData);
            else if (classList.contains("downloadLinkIcon"))
                goToPayments(rowData.receiptId);
            else if (classList.contains("sendToPatientIcon"))
                sendReceiptToPatient(rowData.receiptId);
            else if (classList.contains("sendRefundConfirmationIcon"))
                sendRefundConfirmationToPatient(rowData);
            else if (classList.contains("editPaymentIcon"))
                openRecordPaymentModal(rowData);
        } else if (className.includes("receiptId"))
            goToURL(
                `/Receipts/page=0&size=25&doctor=${rowData.doctorId}&search=${rowData.receiptId}`,
            );
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    const downloadPayment = (id, isRegenerate) => {
        goToDownloadPage(2, id, isRegenerate);
    };

    const regeneratePayment = async (data) => {
        const { receiptId, doctorId, patientId, patientEncounterId } = data;

        const regenerateObj = {
            type: 2,
            entityId: receiptId,
            doctorId,
            patientId,
            patientEncounterId,
        };

        isRegeneratingPayment = true;

        await apiMethods.postMethod
            .regeneratePdfFile(regenerateObj)
            .then((res) => {
                if (res.entityId) downloadPayment(receiptId, true);
                else
                    showError(
                        "Failed to re-generate this payment PDF, please refresh the page and try again and contact support if the issue persists.",
                    );
            })
            .catch((err) =>
                showException(
                    "Failed to re-generate this payment PDF, please refresh the page and try again and contact support if the issue persists.",
                ),
            );

        isRegeneratingPayment = false;
    };

    const goToPayments = (id) => {
        // const url = `https://portal.tcihealth.com.au/?r=${id}`;
        const url = formatPortalUrls("r", id);
        window.open(url, "_blank");
    };

    const sendReceiptToPatient = async (id) => {
        isSendingReceiptToPatient = true;

        await apiMethods.getMethod
            .getReceiptById(id)
            .then(async (res) => {
                if (!res || !res.id || res.error)
                    showError(
                        "Failed to load receipt details, please refresh the page and try again and contact support if the issue persists.",
                    );
                else
                    await apiMethods.postMethod
                        .sendReceiptToPatient(res)
                        .then((res) => {
                            if (res.id) {
                                isReceiptSendToPatient = true;
                            } else
                                showError(
                                    "Failed to send receipt to patient, please refresh the page and try again and contact support if the issue persists.",
                                );
                        });
            })
            .catch((err) => showException(err));

        isSendingReceiptToPatient = false;
    };

    const sendRefundConfirmationToPatient = async (payment) => {
        isSendingPaymentRefundCollectPatientBankDetails = true;

        await apiMethods.postMethod
            .paymentRefundCollectPatientBankDetails(payment)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to send confirmation details to patient, please refresh the page and try again and contact support if the issue persists.",
                    );
                else
                    isPaymentRefundCollectPatientBankDetailsSendToPatient = true;
            });

        isSendingPaymentRefundCollectPatientBankDetails = false;
    };

    // HELPER FUNCTIONS
    const _getReceiptId = (receiptId) => {
        return `<div class="receiptId cursor-pointer hover:underline">${receiptId}</div>`;
    };

    const _getFormatDate = (date) => {
        if (!date || date == "0001-01-01T00:00:00") return "-";

        return getFormatDateAndTime(date);
    };

    const _getAmountForDoctor = (amt, fee) => {
        return getAmountInCurrency(amt - fee);
    };
</script>

<CardLayout title="Payments">
    {#if estimatePayments.length}
        <div class="w-full overflow-x-auto">
            <SvelteTable
                {columns}
                rows={estimatePayments}
                clickCellFunc={({ detail: { event, row, key } }) => {
                    handleClickCell(event, row, key);
                }}
                clickColFunc={({ detail: { event, row, key } }) => {
                    handleClickCol(event, row, key);
                }}
            />
        </div>
    {:else}
        <div class="grid flex-1 h-full card bg-white rounded-box">
            <div class="flex flex-col flex-1 px-2 py-4 w-full lg-flex-row">
                <p>No payments currently under this quote</p>
            </div>
        </div>
    {/if}
</CardLayout>

{#if isDownloadingPayment}
    <LoadingModal titleText="Downloading Payment PDF..." />
{/if}

{#if isRegeneratingPayment}
    <LoadingModal titleText="Regenerating Payment PDF..." />
{/if}

{#if isSendingReceiptToPatient}
    <LoadingModal titleText="Sending Receipt to Patient..." />
{/if}

{#if isSendingPaymentRefundCollectPatientBankDetails}
    <LoadingModal titleText="Sending Confirmation to Patient..." />
{/if}

<NotificationModal
    isModalOpen={isReceiptSendToPatient ||
        isPaymentRefundCollectPatientBankDetailsSendToPatient}
    title="Done"
    showCancelBtn={false}
    submitText="Close"
    confirmAction={() => {
        isReceiptSendToPatient = false;
        isPaymentRefundCollectPatientBankDetailsSendToPatient = false;
    }}
    closeModalFunction={() => {
        isReceiptSendToPatient = false;
        isPaymentRefundCollectPatientBankDetailsSendToPatient = false;
    }}
    hideCrossButton
>
    <p class="leading-6 p-4">
        {isReceiptSendToPatient
            ? "Receipt sent to patient."
            : "Confirmation send to patient."}
    </p>
</NotificationModal>
